/*
 * Public API Surface of administration
 */

export * from './pages/administration.component';
export * from './lib/administration.module';
